<div class="skeleton-doc-card">
    <span class="sk icon"></span>

    <div class="lines">
        <span class="sk line-title"></span>
        <span class="sk line-meta"></span>
    </div>
</div>
